// extracted by mini-css-extract-plugin
export default {"root":"NavBarIconButton_root__vi-hW","selected":"NavBarIconButton_selected__j5erx"};